import appGlobalScript from '/home/runner/work/apie-graphite-layout/apie-graphite-layout/node_modules/@graphiteds/core/dist/collection/global/graphite-global.js';
export const globalScripts = appGlobalScript;
